import type { ButtonHTMLAttributes } from "react";

/** Catalog JerryMark: 32px on-card circle with the happy face glyph in card-lilac. */
const JerryMark = ({ size = 32 }: { size?: number }) => (
  <span
    aria-hidden="true"
    className="inline-flex shrink-0 items-center justify-center rounded-full bg-[var(--ds-on-card)]"
    style={{ width: size, height: size }}
  >
    <span
      className="block bg-[var(--ds-card-lilac)] [mask:url(/brand/jerry-face-mark-ink.svg)_center/contain_no-repeat]"
      style={{ width: size * 0.44, height: size * 0.41 }}
    />
  </span>
);

interface JerryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** 48px on mobile too. */
  compact?: boolean;
}

/** Catalog JerryButton: lilac pill that opens the assistant. 52px mobile, 48px web. */
export const JerryButton = ({ compact = false, className = "", children, type = "button", ...props }: JerryButtonProps) => (
  <button
    type={type}
    className={`app-focus-ring inline-flex shrink-0 cursor-pointer items-center gap-[var(--ds-space-2)] whitespace-nowrap rounded-full border-[1.5px] border-[var(--ds-card-lilac)] bg-[var(--ds-card-lilac)] pl-[var(--ds-space-2)] pr-[var(--ds-space-5)] font-[var(--ds-font-sans)] text-base font-medium leading-none text-[var(--ds-on-card)] transition-[filter] duration-150 hover:brightness-[.94] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--ds-focus)] ${compact ? "h-12" : "h-[52px] md:h-12"} ${className}`}
    {...props}
  >
    <JerryMark />
    {children}
  </button>
);
